import { Component, OnInit } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'sc-field-inline-edit',
  templateUrl: './field-inline-edit.component.html',
  styleUrls: ['./field-inline-edit.component.scss']
})
export class FieldInlineEditComponent extends FieldWrapper implements OnInit {
  ngOnInit(): void {
    this.to.show = true;
  }
}
